const modul = angular.module("BookingCompleteComponents", []);

export default modul.name;
